export const stringToColor = (name?: string | null) => {
  if (!name) return 'primary';
  let hash = 0;
  for (var i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  const colors: string[] = [
    'orange-500',
    'amber-500',
    'yellow-500',
    'lime-500',
    'green-500',
    'emerald-500',
    'teal-500',
    'cyan-500',
    'sky-500',
    'blue-500',
    'indigo-500',
    'violet-500',
    'purple-500',
    'fuchsia-500',
    'pink-500',
  ];

  const options = colors.length;
  const id = Math.abs(hash) % options;
  return colors[id];
};
